import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundApprovalPermittedActionResponse from "./refundApprovalPermittedActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundPermittedActionsResponse {
  @observable
  @Type(() => RefundApprovalPermittedActionResponse)
  approval!: RefundApprovalPermittedActionResponse;
}
